import { render, staticRenderFns } from "./LeadResolveDialog.vue?vue&type=template&id=180b969e"
import script from "./LeadResolveDialog.vue?vue&type=script&lang=ts"
export * from "./LeadResolveDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports